/**
 * Event form component
 * 
 * @module event-form
 * @version 1.0.0
 * @extends HTMLElement
 */

 class eventForm extends HTMLElement {

    /**
     * Event Form web component.
     * 
     * @constructor
     */
    constructor() {

        super();
        
        //This event sends a specifc metric to Klaviyo
        //this.initEvents();
    }

    /**
     * Init events.
     * 
     * @returns {undefined}
     */
    initEvents() {

        window.dataLayer = window.dataLayer || [];

        window.addEventListener('load', () => {

            const comingSoonForm = this.querySelector('form');

            // Check form
            if(comingSoonForm) {

                comingSoonForm.addEventListener('submit', event => {
                    event.preventDefault();
                    
                    //setTimeout(() => {
                        const form = event.target;
                        const email = form.email && form.email.value || '';
                        const publicApiKey = klaviyoModulesObject.companyId || '';
                        const eventId = window.eventId;

                        var objProp = {
                            page: eventId === 'online-events' ? "OnlineEventsLandingPage" : "PhysicalEventsLandingPage",
                            eventId: eventId,
                            email: email
                        }

                        const options = {
                            method: 'POST',
                            headers: {Accept: 'text/html', 'Content-Type': 'application/x-www-form-urlencoded'},
                            body: new URLSearchParams({
                                data: JSON.stringify(
                                    {
                                        token: publicApiKey,
                                        event: eventId === 'online-events' ? "OnlineEventsLandingPage" : "PhysicalEventsLandingPage",
                                        customer_properties: {
                                            $email: email
                                        },
                                        properties: objProp
                                    }
                                )
                            })
                        };

                        
                        try {
                            fetch('https://a.klaviyo.com/api/track', options) 
                            .then(response => response.json())
                            .then(response => console.log("Form sent"))
                            .catch(e => console.error(e));  
                        } catch(error) {
                            console.log(error);
                        } finally {
                            form.submit();
                        }
                    //}, 5000);
                });
            }
        } , false);
    }
}

customElements.define('event-form', eventForm);
